import { fmt, toolEngineLabel, superGroupOf, TOOL_LINE_COLORS } from "@/lib/format";
import { GroupIcon } from "@/lib/groupIcons";

export default function ToolEngineBreakdown({ byToolEngine }) {
  return (
    <section className="rounded-xl bg-white p-4 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_4px_12px_-6px_rgba(15,23,42,0.08)]">
      {!byToolEngine || byToolEngine.length === 0 ? (
        <div className="text-sm text-ink-400">데이터 없음</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-ink-200 text-sm">
            <thead className="bg-ink-50">
              {/* 도구·엔진을 본체 서비스와 같은 조합 표기(경제_교열, 온라인_제목 등)로 통일
                  (2026-07-18 피드백 — "c7, t5 같은 내부 값이 서비스 표기와 다르다").
                  p95 크레딧은 관리자에게 안 읽히는 통계라 제거(같은 피드백). */}
              <tr>
                <Th>도구·엔진</Th>
                <Th align="right">호출 수</Th>
                <Th align="right">크레딧 사용</Th>
              </tr>
            </thead>
            <tbody className="divide-y divide-ink-100">
              {/* 가나다순(2026-07-18 피드백) + 그룹 색 아이콘으로 도구 구분 — 사용량 탭
                  표·필터와 같은 색/모양 언어라 화면 간 이어진다. */}
              {[...byToolEngine]
                .sort((a, b) => toolEngineLabel(a.tool, a.engine).localeCompare(toolEngineLabel(b.tool, b.engine), "ko"))
                .map((r, i) => (
                <tr key={`${r.tool}|${r.engine}|${i}`}>
                  <Td className="whitespace-nowrap">
                    <span className="inline-flex items-center gap-1.5">
                      <GroupIcon superGroup={superGroupOf(r.tool)} color={TOOL_LINE_COLORS[superGroupOf(r.tool)]} className="h-3.5 w-3.5" />
                      {toolEngineLabel(r.tool, r.engine)}
                    </span>
                  </Td>
                  <Td align="right" className="tabular-nums">{fmt.int(r.requestCount)}</Td>
                  <Td align="right" className="tabular-nums">{fmt.nc(r.ncUsed)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}

function Th({ children, align = "left" }) {
  return (
    <th className={`px-3 py-2 text-${align} text-xs font-semibold uppercase tracking-wide text-ink-500`}>
      {children}
    </th>
  );
}

function Td({ children, align = "left", className = "" }) {
  return <td className={`px-3 py-2 text-${align} ${className}`}>{children}</td>;
}
